import { InvoiceSource } from "../../../types/invoice";
import { FinancialAccountBase } from "../../../types/financialAccount";
import { getMatchingIntegrationAccount } from "../../financialAccount";

const STRIPE_INVOICES_BASE_URL = "https://dashboard.stripe.com/invoices";
const MERCURY_INVOICES_BASE_URL = "https://app.mercury.com/invoicing";

interface InvoiceExternalUrlParams {
    invoice: {
        source: InvoiceSource;
        sourceId: string | null;
        financialAccount?: FinancialAccountBase | null;
    };
    billcomBaseUrl: string;
}

export function getInvoiceExternalUrl({
    invoice,
    billcomBaseUrl,
}: InvoiceExternalUrlParams): string {
    if (!invoice.sourceId) {
        return "";
    }

    if (invoice.source === InvoiceSource.STRIPE) {
        const accountId = invoice.financialAccount
            ? getMatchingIntegrationAccount(invoice.financialAccount)
                  ?.sourceAccountId
            : undefined;
        if (!accountId) {
            return "";
        }
        return `${STRIPE_INVOICES_BASE_URL}/${invoice.sourceId}?account=${accountId}`;
    }

    if (invoice.source === InvoiceSource.MERCURY) {
        return `${MERCURY_INVOICES_BASE_URL}?id=${invoice.sourceId}`;
    }

    if (invoice.source === InvoiceSource.BILLCOM) {
        return `${billcomBaseUrl}/neo/invoice/${invoice.sourceId}`;
    }

    return "";
}
